<template>
  <div class="content-grid-raw">
    <NSpace
      v-if="items.length && (data.layout_type === ContentGridLayoutTypes.GRID || !data.layout_type)"
      class="py-2"
      justify="center"
      :size="8"
      wrap
    >
      <ContentGridItem
        v-for="(item, index) in items"
        :key="item.file.id"
        :all-items="items"
        :index="index"
        :item="item"
        show-preview-thumbnails
        :used-in-section-id="usedInSectionId"
        @deleted-file-clicked="emit('deletedFileClicked')"
      />
    </NSpace>

    <ContentGridCarousel
      v-else-if="items.length && data.layout_type === ContentGridLayoutTypes.CAROUSEL"
      :items="items"
      :used-in-section-id="usedInSectionId"
    />

    <ContentGridList
      v-else-if="items.length && data.layout_type === ContentGridLayoutTypes.LIST"
      :items="items"
      :used-in-section-id="usedInSectionId"
      @deleted-file-clicked="emit('deletedFileClicked')"
    />
  </div>
</template>

<script setup lang="ts">
import { NSpace } from 'naive-ui'
import { computed } from 'vue'

import { ContentGridLayoutTypes, type ContentGridProps } from '@canvas-builder/types/canvas'
import useCanvas from '@canvas-builder/composables/useCanvas'
import ContentGridItem from './ContentGridItem.vue'
import ContentGridCarousel from './ContentGridCarousel.vue'
import ContentGridList from './ContentGridList.vue'
import type { CanvasRetrieve } from '@openapi'

const props = defineProps<{
  data: ContentGridProps
  usedInSectionId?: CanvasRetrieve['id']
}>()

const emit = defineEmits<{
  (e: 'deletedFileClicked'): void
}>()

const { isEditMode } = useCanvas()

const items = computed(
  () => (isEditMode.value ? props.data.items : props.data.items.filter((item) => !item.file?.is_deleted)) ?? [],
)
</script>
